export const Colors = {
  white: '#FFFFFF',
  black: '#000000',
  light: '#F5F8F9',
  lightBlue: '#CCDBFF',
  darkGray: '#333333',
  blue: '#0560FD',
}